<template>
  <div @click="back" class="header border-bottom">
    <i class="iconfont">&#xe604;</i>
  </div>
</template>

<script>
export default {
  name: 'ReleaseHeader',
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped>
.iconfont{ font-size: 25px;}
.header{ padding: 10px 15px; padding-bottom: 5px;}
</style>



// WEBPACK FOOTER //
// src/pages/release/components/Header.vue